import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

interface DialogueState {
    dialogues: any,
}

const initialState: DialogueState = {
    dialogues: [],
}

export const dialogueSlice = createSlice({
    name: 'dialogue',
    initialState,
    reducers: {
        setDialogues: (state, action: PayloadAction<any>) => {
            state.dialogues = action.payload
        },
        pushDialogues: (state, action: PayloadAction<any>) => {
            state.dialogues.push(action.payload)
        }
    },
})


export const {
    setDialogues,
    pushDialogues,
} = dialogueSlice.actions

export default dialogueSlice.reducer
